import Close from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

interface PdfPrintDialogShellProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	fullWidth?: boolean;
	children: React.ReactNode;
}

/**
 * Generic dialog shell reused by PDF print dialogs (service protocol, health
 * check, ...). Renders the dialog frame, the title and a close button. The
 * concrete feature provides the body via children.
 */
export const PdfPrintDialogShell = ({
	isOpen,
	onClose,
	title,
	fullWidth,
	children,
}: PdfPrintDialogShellProps) => (
	<Dialog
		open={isOpen}
		fullWidth={fullWidth}
		maxWidth={'lg'}
		sx={{
			whiteSpace: 'pre-line',
		}}>
		<DialogTitle sx={{ marginRight: 2 }}>
			{title}
			<IconButton
				aria-label="close"
				onClick={onClose}
				sx={(theme) => ({
					position: 'absolute',
					right: theme.spacing(1),
					top: theme.spacing(1.5),
					color: theme.palette.grey[500],
				})}>
				<Close />
			</IconButton>
		</DialogTitle>
		{children}
	</Dialog>
);
